module.exports = __webpack_public_path__ + "static/media/S (156).3ca6bb52.jpg";